/**
 * Persist All Products toolbar filters and view options in localStorage.
 * Server-side sort, bulk assign, and export need API support separately.
 */

const STORAGE_FILTERS = 'spv.adminProducts.filters.v1'
const STORAGE_COLUMNS = 'spv.adminProducts.columns.v1'

export function loadAdminProductsFilters() {
	try {
		const raw = localStorage.getItem(STORAGE_FILTERS)
		return raw ? JSON.parse(raw) : null
	} catch (e) {
		return null
	}
}

export function saveAdminProductsFilters(state) {
	const payload = {
		manufacturerFilter: state.manufacturerFilter,
		productTypeFilter: state.productTypeFilter,
		batteryComponentTypeFilter: state.batteryComponentTypeFilter,
		isSmartFilter: state.isSmartFilter,
		filter: state.filter,
	}
	try {
		localStorage.setItem(STORAGE_FILTERS, JSON.stringify(payload))
	} catch (e) {
		// ignore quota / private mode
	}
}

export function loadAdminProductsColumns() {
	try {
		const raw = localStorage.getItem(STORAGE_COLUMNS)
		return raw ? JSON.parse(raw) : null
	} catch (e) {
		return null
	}
}

export function saveAdminProductsColumns(prefs) {
	try {
		localStorage.setItem(STORAGE_COLUMNS, JSON.stringify(prefs))
	} catch (e) {
		// ignore
	}
}
